import { del, get, post, put } from './request'

interface Attraction {
    supplier: string;
    propertyId: string;
    property: {
        attractions: Array<object>
    };
}

export const getAttractions = (supplier: string, propertyid: string) => get(`/property/attractions?supplier=${supplier}&propertyid=${propertyid}`)
export const addAttraction = (attraction: Attraction) => post('/property/attractions', attraction)
export const updateAttraction = (attraction: Attraction) => put('/property/attractions', attraction)
export const deleteAttraction = (attraction: Attraction) => del('/property/attractions', attraction)

export const addAttractionLocation = (attraction: Attraction) => post('/property/attractions/locations', attraction)
export const updateAttractionLocation = (attraction: Attraction) => put('/property/attractions/locations', attraction)
export const deleteAttractionLocation = (attraction: Attraction) => del('/property/attractions/locations', attraction)